import { Loader2 } from "lucide-react";

export default function CheckoutVerification({ verification, testId = "checkout-verification" }) {
  if (["idle", "complete"].includes(verification.status)) return null;
  return (
    <section className="card-soft p-4 space-y-3 text-sm" role="status" data-testid={testId}>
      <p className="flex items-start gap-2">
        {verification.status === "checking" && <Loader2 className="h-4 w-4 shrink-0 animate-spin" />}
        {verification.message}
      </p>
      {["pending", "error"].includes(verification.status) && (
        <button type="button" onClick={verification.retry} className="btn-ghost" data-testid={`${testId}-retry`}>Verifica di nuovo</button>
      )}
    </section>
  );
}
